import Signup from './src/main';

/* istanbul ignore next */
Signup.install = function(Vue) {
  // 注册父组件
  Vue.component(Signup.name, Signup);
};

export default Signup;
